module.exports = __webpack_public_path__ + "img/estrella.dacd4ecb.svg";